'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Component';

  if (!Component) {
    return fallback;
  }
  return Component.displayName || Component.name || Component.type && (Component.type.displayName || Component.type.name) || fallback;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.100/js/getComponentName.js
// module id = 42
// module chunks = 177